// @ts-nocheck
import {
  resolveSpeciesLabel,
  speciesKeyFromLabel,
  toggleSpeciesOtherField,
} from "./breeds";
import { bindBreedCombobox } from "./breed-combobox";
import { t } from "../i18n";

export function validatePetDates(birth: string, death: string): string | null {
  if (!birth || !death) return null;
  if (death < birth) {
    return t("petForm.deathBeforeBirth");
  }
  return null;
}

export function readPetFormFields(prefix: string) {
  const inpName = document.getElementById(`${prefix}-name`) as HTMLInputElement | null;
  const selSpecies = document.getElementById(`${prefix}-species`) as HTMLSelectElement | null;
  const inpSpeciesOther = document.getElementById(`${prefix}-species-other`) as HTMLInputElement | null;
  const inpBreed = document.getElementById(`${prefix}-breed`) as HTMLInputElement | null;
  const inpBirth = document.getElementById(`${prefix}-birth`) as HTMLInputElement | null;
  const inpDeath = document.getElementById(`${prefix}-death`) as HTMLInputElement | null;
  const inpText = document.getElementById(`${prefix}-text`) as HTMLTextAreaElement | null;
  const inpPhoto = document.getElementById(`${prefix}-photo-input`) as HTMLInputElement | null;

  const name = inpName?.value.trim() ?? "";
  const epitaph = inpText?.value.trim() ?? "";
  const species =
    selSpecies && inpSpeciesOther
      ? resolveSpeciesLabel(selSpecies, inpSpeciesOther)
      : undefined;
  const breed = inpBreed?.value.trim() || undefined;
  const birthDate = inpBirth?.value || undefined;
  const deathDate = inpDeath?.value || undefined;

  return {
    inpName,
    selSpecies,
    inpSpeciesOther,
    inpBreed,
    inpBirth,
    inpDeath,
    inpText,
    inpPhoto,
    name,
    epitaph,
    species,
    breed,
    birthDate,
    deathDate,
  };
}

export function clearPetFormFields(prefix: string) {
  const ids = [
    `${prefix}-name`,
    `${prefix}-breed`,
    `${prefix}-birth`,
    `${prefix}-death`,
    `${prefix}-text`,
    `${prefix}-species-other`,
  ];
  ids.forEach((id) => {
    const el = document.getElementById(id) as HTMLInputElement | HTMLTextAreaElement | null;
    if (el) el.value = "";
  });
  const species = document.getElementById(`${prefix}-species`) as HTMLSelectElement | null;
  if (species) species.value = "";
  const photo = document.getElementById(`${prefix}-photo-input`) as HTMLInputElement | null;
  if (photo) photo.value = "";
}

let graveBreedUnbind: (() => void) | null = null;
let graveSpeciesOtherUnbind: (() => void) | null = null;

export function setupGravePetFormBindings() {
  graveBreedUnbind?.();
  graveSpeciesOtherUnbind?.();
  const species = document.getElementById("grave-species") as HTMLSelectElement | null;
  const breed = document.getElementById("grave-breed") as HTMLInputElement | null;
  const otherWrap = document.getElementById("grave-species-other-wrap");
  const other = document.getElementById("grave-species-other") as HTMLInputElement | null;
  if (!species || !breed || !otherWrap || !other) return;
  graveBreedUnbind = bindBreedCombobox(species, breed);
  graveSpeciesOtherUnbind = toggleSpeciesOtherField(species, otherWrap, other);
}

export function fillPetFormFields(
  prefix: string,
  data: {
    name?: string;
    species?: string;
    breed?: string;
    birthDate?: string;
    deathDate?: string;
    epitaph?: string;
  },
) {
  const nameEl = document.getElementById(`${prefix}-name`) as HTMLInputElement | null;
  const speciesEl = document.getElementById(`${prefix}-species`) as HTMLSelectElement | null;
  const otherEl = document.getElementById(`${prefix}-species-other`) as HTMLInputElement | null;
  const breedEl = document.getElementById(`${prefix}-breed`) as HTMLInputElement | null;
  const birthEl = document.getElementById(`${prefix}-birth`) as HTMLInputElement | null;
  const deathEl = document.getElementById(`${prefix}-death`) as HTMLInputElement | null;
  const textEl = document.getElementById(`${prefix}-text`) as HTMLTextAreaElement | null;

  if (nameEl && data.name) nameEl.value = data.name;
  if (breedEl) breedEl.value = data.breed ?? "";
  if (birthEl) birthEl.value = data.birthDate ?? "";
  if (deathEl) deathEl.value = data.deathDate ?? "";
  if (textEl) textEl.value = data.epitaph ?? "";

  if (speciesEl && data.species) {
    const key = speciesKeyFromLabel(data.species);
    if (key && key !== "other") {
      speciesEl.value = key;
      if (otherEl) otherEl.value = "";
    } else if (key === "other" || !key) {
      const known = Array.from(speciesEl.options).some((o) => o.value === data.species);
      if (known) {
        speciesEl.value = data.species;
        if (otherEl) otherEl.value = "";
      } else {
        speciesEl.value = "other";
        if (otherEl) otherEl.value = data.species;
      }
    }
    speciesEl.dispatchEvent(new Event("change"));
  }
}

export function buildPetPayloadFromForm(prefix: string) {
  const f = readPetFormFields(prefix);
  const pet: Record<string, string> = { name: f.name };
  if (f.species) pet.species = f.species;
  if (f.breed) pet.breed = f.breed;
  if (f.birthDate) pet.birthDate = f.birthDate;
  if (f.deathDate) pet.deathDate = f.deathDate;
  return { ...f, pet };
}
